var name = "@zooplus/header-account-flyout";
var version = "3.0.19";
var description = "The Header Account Flyout displays account-related navigation in the shop header.";
var author = "Madflys";
var license = "ISC";
var main = "./dist/cjs/index.js";
var types = "./dist/es/src/index.d.ts";
var module = "./dist/es/index.js";
var engines = {
	node: ">=20",
	npm: ">=10"
};
var scripts = {
	start: "npm run storybook",
	dev: "webpack serve --mode=development --config webpack-config.js --hot --env index=true",
	build: "rollup -c",
	typecheck: "tsc --noEmit --watch --preserveWatchOutput --pretty",
	storybook: "storybook dev -p 6006",
	"storybook-build": "storybook build",
	lint: "eslint \"**/*.{ts,tsx,js,jsx,cjs}\"",
	"lint:fix": "eslint \"**/*.{ts,tsx,js,jsx,cjs}\" --fix",
	test: "vitest",
	"test:ci": "vitest run --coverage"
};
var files = [
	"Readme.md",
	"CHANGELOG.md",
	"dist/"
];
var devDependencies = {
	"@sentry/browser": "^6.10.0",
	"@testing-library/dom": "^8.17.1",
	"@testing-library/jest-dom": "^6.4.5",
	"@testing-library/react": "^12.1.5",
	"@testing-library/user-event": "^14.4.3",
	"@types/jest-axe": "^3.5.4",
	"@types/node": "^18.7.5",
	"@types/react": "^18.0.17",
	"@types/react-dom": "^18.0.6",
	"@vitest/coverage-istanbul": "1.6.0",
	"@zooplus/commons-lang": "2.0.0",
	"@zooplus/frontend-scripts": "6.0.3",
	"@zooplus/icons": "^1.5.1",
	"@zooplus/madflys-frontend-configs": "1.1.0",
	"@zooplus/myaccount-storybook": "2.1.6",
	"@zooplus/myaccount-utils": "6.5.3",
	"events-bus": "^1.0.1",
	"happy-dom": "14.11.0",
	i18next: "^21.8.3",
	msw: "^2.3.0",
	"prop-types": "15.7.2",
	react: "17.0.2",
	"react-dom": "17.0.2",
	"react-i18next": "^11.16.9",
	"ts-jest": "^28.0.8",
	tslib: "^2.4.0",
	typescript: "^5.4.5",
	vitest: "1.6.0",
	"vitest-axe": "0.1.0"
};
var peerDependencies = {
	"@sentry/browser": ">=6",
	"@zooplus/icons": ">=1.5.1",
	"events-bus": ">=1.0.1",
	i18next: ">=21.8.3",
	react: ">=17.0.2",
	"react-dom": ">=17.0.2",
	"react-i18next": ">=11.16.9"
};
var packageInfo = {
	name: name,
	version: version,
	description: description,
	author: author,
	license: license,
	main: main,
	types: types,
	module: module,
	"jsnext:main": "./dist/es/index.js",
	engines: engines,
	scripts: scripts,
	files: files,
	devDependencies: devDependencies,
	peerDependencies: peerDependencies
};

export { author, packageInfo as default, description, devDependencies, engines, files, license, main, module, name, peerDependencies, scripts, types, version };
//# sourceMappingURL=package.json.js.map
